export default __webpack_public_path__ + "static/media/36I-114284_-20947_0.518cdee2.jpg";